import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import { getSalesReport } from '@/api/scm/sales-report';
import moment from "moment";
import {
	getBuyer30SaleData,
	// getBuyerSaleData,
	getCategoryPieData,
	getGoodsSalesReportList,
	getShopList,
	getShopPieData
} from "@/api/scm/goods-sales-report";
import {fetchList} from "@/api/sms/forwarding-order";
const today = moment().format('L')
export default extend(table, {
	namespaced: true,
	state: {
		shopList: [],
		searchForm: {
			// time: [`${today} 00:00:00`, `${today} 23:59:59`]
		},
		shopPieData: [],
		categoryPieData: [],
		buyerSaleData: [],
		buyer30SaleData: []
	},
	actions: {
		async getShopList({ state, dispatch, commit }, payload){
			await wait(dispatch, 'scm.goods-sales-report.index', async function () {
				const response = await getShopList({
					...payload
				})
				if (response.data) {
					commit('save', {
						shopList: response.data
					})
				}
			})
		},
		async getShopPieData({ state, dispatch, commit }, payload){
			await wait(dispatch, 'scm.goods-sales-report.index', async function () {
				const { searchForm } = state;
				const response = await getShopPieData({
					shopIdList: searchForm.shopIdList,
					goodsIdList: (searchForm.goodsId && searchForm.goodsId.split(',')) || [],
					startTime: searchForm.time && new Date(searchForm.time[0]).getTime() / 1000,
					endTime: searchForm.time && new Date(searchForm.time[1]).getTime() / 1000,
					...payload
				})
				if (response.data) {
					commit('save', {
						shopPieData: response.data
					})
				}
			})
		},
		async getCategoryPieData({ state, dispatch, commit }, payload){
			await wait(dispatch, 'scm.goods-sales-report.index', async function () {
				const { searchForm } = state;
				const response = await getCategoryPieData({
					shopIdList: searchForm.shopIdList,
					goodsIdList: (searchForm.goodsId && searchForm.goodsId.split(',')) || [],
					startTime: searchForm.time && new Date(searchForm.time[0]).getTime() / 1000,
					endTime: searchForm.time && new Date(searchForm.time[1]).getTime() / 1000,
					...payload
				})
				if (response.data) {
					commit('save', {
						categoryPieData: response.data
					})
				}
			})
		},
		/*async getBuyerSaleData({ state, dispatch, commit }, payload){
			await wait(dispatch, 'scm.goods-sales-report.index', async function () {
				const { searchForm } = state;
				const response = await getBuyerSaleData({
					shopIdList: searchForm.shopIdList,
					goodsIdList: (searchForm.goodsId && searchForm.goodsId.split(',')) || [],
					startTime: new Date(searchForm.time[0]).getTime() / 1000,
					endTime: new Date(searchForm.time[1]).getTime() / 1000,
					...payload
				})
				if (response.data) {
					commit('save', {
						buyerSaleData: response.data
					})
				}
			})
		},*/
		async getBuyer30SaleData({ state, dispatch, commit }, payload){
			await wait(dispatch, 'scm.goods-sales-report.index', async function () {
				const { searchForm } = state;
				const response = await getBuyer30SaleData({
					shopIdList: searchForm.shopIdList,
					goodsIdList: (searchForm.goodsId && searchForm.goodsId.split(',')) || [],
					startTime: searchForm.time && new Date(searchForm.time[0]).getTime() / 1000,
					endTime: searchForm.time && new Date(searchForm.time[1]).getTime() / 1000,
					...payload
				})
				if (response.data) {
					commit('save', {
						buyer30SaleData: response.data
					})
				}
			})
		},
		async getList({ state, dispatch }, payload) {
			await wait(dispatch, 'scm.goods-sales-report.index', async function () {
				const { searchForm } = state;
				console.log(searchForm.goodsId && searchForm.goodsId.split(','))
				await dispatch('getData', {
					caller: getGoodsSalesReportList,
					options: {
						shopIdList: searchForm.shopIdList,
						goodsIdList: (searchForm.goodsId && searchForm.goodsId.split(',')) || [],
						startTime: searchForm.time && new Date(searchForm.time[0]).getTime() / 1000,
						endTime: searchForm.time && new Date(searchForm.time[1]).getTime() / 1000,
						...payload
					}
				});
			})
		},
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/scm/goods-sales-report/index.js